import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse, IUri } from '../../BaseService';
import { prepareUrl } from '../BuildUrls';
import { IChannels } from '../Types';

const RESOURCE = 'channels';

interface IGetChannel extends Omit<IUri, 'resource'> {
  appKey: string;
}

interface IGetChannelResponse extends IHttpResponse {
  body?: IChannels;
}

export default async ({
  appKey,
  ...buildUrlProps
}: IGetChannel): Promise<IGetChannelResponse> => {
  const url = prepareUrl({
    ...buildUrlProps,
    resource: RESOURCE,
  });

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({ url, appKey, token: guestToken });
};
